import gsap from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"

export class LiquidityProgress {
  constructor() {
    this.isInitialized = false
    this.scrollTrigger = null
    this.timeline = null
    this.resizeHandler = null
    this.isMobile = false

    // Desktop 
    this.animatedLines = document.querySelector(".animated-lines")
    this.animatedTags = document.querySelector(".animated-tags")
    this.tagGroups = gsap.utils.toArray(".animated-tags > g")

    // Mobile 
    this.mobileLines = document.querySelector("#liquidityLinesMobile")
    this.mobileGroups = gsap.utils.toArray("#liquidityLinesMobile > g")
  }

  init() {
    if (this.isInitialized) return

    gsap.registerPlugin(ScrollTrigger)
    this.checkViewport()
    this.initAnimation()
    this.bindResize()
    this.isInitialized = true
  }

  checkViewport() {
    this.isMobile = window.innerWidth <= 479
  }

  initAnimation() {
    this.cleanup()
    this.checkViewport()

    if (this.isMobile) {
      this.initMobileAnimation()
    } else {
      this.initDesktopAnimation()
    }
  }

  initDesktopAnimation() {
    if (!this.animatedLines) return

    this.timeline = gsap.timeline()
      .fromTo(this.animatedLines, {
        webkitMaskPosition: "0% 100%",
        maskPosition: "0% 100%"
      }, {
        webkitMaskPosition: "0% 0%",
        maskPosition: "0% 0%",
        duration: 1,
        ease: "power2.inOut"
      })

    this.scrollTrigger = ScrollTrigger.create({
      trigger: "#liquiditySection",
      start: "top 100%",
      end: "bottom 40%",
      scrub: 1,
      animation: this.timeline,
    })
  }

  initMobileAnimation() {
    // Target the HTML wrapper instead of SVG group
    const mobileMaskWrapper = document.querySelector(".liquidity_mobile_mask")
    if (!mobileMaskWrapper) return

    this.timeline = gsap.timeline()
      .fromTo(mobileMaskWrapper, {
        clipPath: "inset(0% 0% 100% 0%)",
      }, {
        clipPath: "inset(0% 0% 0% 0%)",
        duration: 1,
        ease: "power2.inOut"
      })


    this.scrollTrigger = ScrollTrigger.create({
      trigger: "#liquiditySection",
      start: "top 50%",
      end: "bottom 80%",
      scrub: 1,
      animation: this.timeline,
    })
  }

  bindResize() {
    this.resizeHandler = this.debounceResize(() => {
      const wasM = this.isMobile
      this.checkViewport()

      // Only reinit if viewport type changed
      if (wasM !== this.isMobile) {
        ScrollTrigger.refresh()
        this.initAnimation()
      }
    }, 250)
    window.addEventListener("resize", this.resizeHandler)
  }

  debounceResize(fn, ms) {
    let last = innerWidth
    let timer
    return function (...args) {
      clearTimeout(timer)
      timer = setTimeout(() => {
        if (innerWidth !== last) {
          last = innerWidth
          fn.apply(this, args)
        }
      }, ms)
    }
  }

  cleanup() {
    if (this.scrollTrigger) {
      this.scrollTrigger.kill()
      this.scrollTrigger = null
    }
    if (this.timeline) {
      this.timeline.kill()
      this.timeline = null
    }
  }

  destroy() {
    this.cleanup()
    if (this.resizeHandler) {
      window.removeEventListener("resize", this.resizeHandler)
      this.resizeHandler = null
    }

    this.isInitialized = false
  }
}